<template>
  <div class="main mainIndiv" v-if="!loading && maxMax == false">
    <div class="wrapPortable wpSession">
      <h1 class="session_h1">
        Exercice n°{{ video.position }}/ {{ tailleMax }}
      </h1>
    </div>
    <div class="session_ind">
      <div class="video-responsive">
        <div class="noteVideo">
          <button
            @click.prevent="activeDesc = true"
            v-if="activeDesc == false"
            class="boutonInfo"
          >
            <i class="fa fa-angle-down"></i>
          </button>
          <button @click.prevent="activeDesc = false" v-else class="boutonInfo">
            <i class="fa fa-angle-up"></i>
          </button>

          <button
            :class="[activeNote == 'plus' ? 'actived' : '', 'notePlus']"
            @click.prevent="changeNote(+1)"
          >
            <i
              :class="[
                'fa fa-thumbs-o-up logoPHaut',
                activeNote == 'plus' ? 'activeFa' : '',
              ]"
              aria-hidden="true"
            ></i>
          </button>
          <button
            :class="[activeNote == 'moins' ? 'actived' : '', 'noteNeg']"
            @click.prevent="changeNote(-1)"
          >
            <i
              :class="[
                'fa fa-thumbs-o-down logoPBas',
                activeNote == 'moins' ? 'activeFa' : '',
              ]"
              aria-hidden="true"
            ></i>
          </button>
        </div>
        <!--<button class="precedent" @click.prevent="changePosition(-1)"> &#x3008; </button>-->
        <iframe
          v-if="video.url !== 'undefined'"
          :src="
            'https://player.vimeo.com/video/' +
            video.url +
            '?autoplay=1&background=1'
          "
          width="640"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          class="video"
          id="video"
        ></iframe>
        <iframe
          v-else
          :src="
            'https://player.vimeo.com/video/' +
            video.firstUrl +
            '?autoplay=1&background=1'
          "
          width="640"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen"
          allowfullscreen
          class="video"
        ></iframe>
        <!--<button class="suivant" @click.prevent="changePosition(+1)"> &#x3009; </button>-->
      </div>

      <div class="alert alertInd" v-if="activeDesc == true">
        <p class="pimage">
          <img src="../assets/logo/logo-info.png" alt="logo-info" />
        </p>
        <p class="alert-info" v-if="video.description !== 'undefined'">
          {{ video.description }}
        </p>
        <p class="alert-info" v-if="infos == null">
          Description lièe à la vidéo
        </p>
        <p class="alert-info" v-else>
          {{ infos[video.position - 1].desc }}
        </p>
      </div>
    </div>
    <!--
    <div>
      {{ video.url }}
      {{ video.description }}
    </div>-->
  </div>
  <div class="main mainIndiv wrapPortable main22" v-else-if="maxMax == true">
    <div class="session_ind sessionFinVideo">
      <h1>Merci d'avoir participé</h1>
      <div class="finVideo">
        <router-link
          to="Accueil"
          class="submitQuestionnaire finVideoBoutton"
          title="retour Accueil"
        >
          Accueil
        </router-link>
        <router-link
          to="/deconnexion"
          class="submitQuestionnaire finVideoBoutton"
          title="se déconnecter"
        >
          Quitter l'application
        </router-link>
      </div>
    </div>
  </div>
  <div class="main mainIndiv mainLoader" v-else>
    <circleLoader :when="loading"></circleLoader>
  </div>
</template>

<script>
import Autocomplete from "vuejs-auto-complete";
import circleLoader from "@/components/Circle-loader";
import { User } from "../controller/user.js";
import { VideoCollection } from "@/controller/Video.js";
import { hostUrl } from "../_helpers/global_var";
import * as controle from "@/controller/correctionEcran.js";
import screenfull from "screenfull";

//définir une fonction qui va me permettre de ne pas me faire passer par lenght afin d'obtenir la longueur de mmon tableau d'objects
//define a function which will allow me not to pass by lenght in order to obtain the length of mmon array of objects
Object.size = function (obj) {
  var size = 0,
    key;
  for (key in obj) {
    if (obj.hasOwnProperty(key)) size++;
  }
  return size;
};

function getRandomIntInclusive(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const axios = require("axios").default;
const tempo = 60000;

/*import { Song } from "../controller/song.js"*/

export default {
  name: "Session_Individuel",
  data() {
    return {
      user: JSON.parse(localStorage.user) || [],
      /*song: new Song,*/
      video: {
        url: "undefined",
        position: 1,
        description: "undefined",
        position1: false,
      },
      tailleMax: "",
      maxMax: false,
      note: [],
      activeNote: false,
      activeDesc: true,
      loading: true,
      infos: null,
    };
  },
  components: {
    Autocomplete,
    circleLoader,
  },
  beforeCreate() {
    if (typeof localStorage.video !== undefined) {
      //console.log(JSON.parse(localStorage.video));
    } else {
      new VideoCollection(
        this.user.metier,
        this.user.niveau,
        this.user.salarie_id
      );
    }
  },
  created() {
    this.loading = true;
    if (typeof localStorage.user !== undefined) {
      this.user = JSON.parse(localStorage.user);
      //console.log(this.user);
    } else {
      console.log("var not exist");
    }
    let user = JSON.parse(localStorage.user);

    async function loadLocal() {
      let uri = "";
      if (
        user.metier == null ||
        user.niveau == null ||
        user.salarie_id == null
      ) {
        uri = hostUrl + "/all_video";
        localStorage.uriAll = true;
      } else {
        uri =
          hostUrl +
          "/protocole/" +
          user.metier +
          "/" +
          user.niveau +
          "/" +
          user.salarie_id;
        localStorage.uriAll = false;
      }
      console.log(uri, user);
      await axios
        .get(uri)
        .then(
          (response) => (localStorage.video = JSON.stringify(response.data))
        )
        .catch((error) => console.log(error));
    }
    loadLocal().then(() => {
      if (typeof localStorage.video !== "undefined") {
        if (typeof localStorage.video !== undefined) {
          /*-----------------------Methode 1 prommesse appellée et stockée---------------------------- */

          //step1 : appel de l'object VideoCollection qui va avoir comme but d'instancier la prommesse et de stocker les dates si réusites
          //step1 : call of the VideoCollection object which will have the aim of instantiating the promise and storing the dates if successful
          //this.collection = new VideoCollection(this.user.metier, this.user.niveau, this.user.salarie_id);
          //console.log(JSON.parse(localStorage.video));
          //step2 : récupération de nos data sous format json donc comme c'est un objet js on peut (et devons) le parser
          //step2 : recovery of our data in json format so as it is a js object we can (and must) parse it
          if (typeof localStorage.video !== "undefined") {
            this.collection = JSON.parse(localStorage.video);
            //step3 : definir l'url pour ifram
            //step3 : define url for ifram
            //this.video.firstUrl = JSON.parse(localStorage.firstUrl);

            //step4 : definr la taille max pour la vue et les méthodes
            //step4 : define tailleMax object for the vue and the metods
            this.tailleMax = Object.size(this.collection);
            var arrayAD = [];

            //console.log(localStorage.uriAll)
            if (
              this.tailleMax > 25 &&
              localStorage.uriAll !== undefined &&
              JSON.parse(localStorage.uriAll) == true
            ) {
              let arrayFini = [];
              for (let index = 0; index < 10; index++) {
                let koko = getRandomIntInclusive(0, this.tailleMax);
                while (arrayAD.includes(koko)) {
                  koko = getRandomIntInclusive(0, this.tailleMax);
                }
                arrayAD.push(koko);
                if (this.collection[koko] !== null) {
                  arrayFini[index] = this.collection[koko];
                } else {
                  let koko = getRandomIntInclusive(0, this.tailleMax);
                  while (arrayAD.includes(koko)) {
                    koko = getRandomIntInclusive(0, this.tailleMax);
                  }
                  arrayAD.push(koko);
                  arrayFini[index] = this.collection[koko];
                }
              }
              this.collection = arrayFini;
              this.tailleMax = Object.size(this.collection);
              localStorage.removeItem("uriAll");
              localStorage.video = JSON.stringify(this.collection);
            }
            this.video.url = this.collection[this.video.position - 1].url;
          }

          if (this.tailleMax > 25) {
            let arrayFini = [];
            for (let index = 0; index < 15; index++) {
              let koko = getRandomIntInclusive(0, this.tailleMax);
              while (arrayAD.includes(koko)) {
                koko = getRandomIntInclusive(0, this.tailleMax);
              }
              arrayAD.push(koko);
              if (this.collection[koko] !== null) {
                arrayFini[index] = this.collection[koko];
              } else {
                let koko = getRandomIntInclusive(0, this.tailleMax);
                while (arrayAD.includes(koko)) {
                  koko = getRandomIntInclusive(0, this.tailleMax);
                }
                arrayAD.push(koko);
                arrayFini[index] = this.collection[koko];
              }
            }
            this.collection = arrayFini;
            this.tailleMax = Object.size(this.collection);
            localStorage.video = JSON.stringify(this.collection);
          }
          this.video.url = this.collection[this.video.position - 1].url;
          this.loading = false;
          console.log("reussite", localStorage.video);
        } else {
          console.log("var not exist");
        }
      } else {
        console.log("echec");
      }

      try {
        this.getInfos(JSON.parse(localStorage.video)).then(
          () => (this.infos = JSON.parse(localStorage.videoInfo))
        );
        this.getInfos(JSON.parse(localStorage.video)).catch(
          () => (this.infos = null)
        );
      } catch (error) {
        this.infos = null;
      }
    });

    if (this.info == null) {
      try {
        this.getInfos(JSON.parse(localStorage.video)).then(
          () => (this.infos = JSON.parse(localStorage.videoInfo))
        );
        this.getInfos(JSON.parse(localStorage.video)).catch(
          () => (this.infos = null)
        );
      } catch (error) {
        this.infos = null;
      }
    }

    /*---------------------Methode 2 prommesse imbriquées--------------------------- */

    // !! important ouvrir Video.js afin de constater la requête axios ajax!!
    // Debut des promesses step 1 = raccourcir l'expression
    // Beginning of the promises step 1 = shorten the expression

    //this.collection = this.collection.then;*/

    //------this.collection.then(response => this.video.url = response[0].url);
    //step 2 definir la taille max du tableau ou si erreur la faire remonter en console
    //step 2 define the maximum size of the table or if error bring it up in console
    //this.collection.then(result => this.tailleMax = Object.size(result)).catch(error => console.log(error));
    //step 3 prevoir l'échec
    //step 3 predict failure
    //let preview = this.video.url;
    //chercher dans le tableau d'object promesse la bonne video par rapport à la position ou si erreur la faire remonter en console et definir l'url de la video sur la précédente
    //search in the object table promises the right video in relation to the position or if error bring it back up in console and define the url of the video on the previous one
    //this.collection.then(response => this.video.url = response[this.video.position -1].url).catch(error => console.log(error), this.video.url = preview);
  },
  mounted() {
    if (this.loading == false) {
      if (localStorage.video == undefined) {
        console.log("echec");
      } else {
        //console.log(JSON.parse(localStorage.video));
      }
      if (JSON.parse(localStorage.video) !== "undefined") {
        this.video.url = this.collection[this.video.position - 1].url;
      }
    }
    this.load = setInterval(() => this.changePosition(+1), tempo);
    window.addEventListener("orientationchange", function () {
      let koko = this.document.getElementById("video");
      if (screenfull.isEnabled) {
        if (
          screenfull.isFullscreen == false &&
          screen.orientation.type == "landscape-primary"
        ) {
          koko.classList.add("videoKoko");
        } else {
          koko.classList.remove("videoKoko");
        }
      }
    });
  },

  methods: {
    videoLink() {
      if (this.video.position < this.tailleMax + 1 && this.video.position > 0) {
        let preview = this.video.url;
        this.video.url = this.collection[this.video.position - 1].url;
        //chercher dans le tableau d'object promesse la bonne video par rapport à la position ou si erreur la faire remonter en console et definir l'url de la video sur la précédente
        //search in the object table promises the right video in relation to the position or if error bring it back up in console and define the url of the video on the previous one
        //this.collection.then(response => this.video.url = response[this.video.position -1].url).catch(error => console.log(error), this.video.url = preview);
      }
    },
    changePosition(order) {
      this.activeNote = false;
      //console.log(this.video.position);
      if (order < 0) {
        if (this.video.position > 1) {
          this.video.position--;
          this.videoLink();
        }
      } else if (order > 0) {
        if (this.video.position < this.tailleMax) {
          this.video.position++;
          this.videoLink();
        }

        if (this.maxMax !== false) {
          clearInterval(this.load);
          localStorage.note = JSON.stringify(this.note);
          this.postVideoConsultée();
        }
        if (this.video.position == this.tailleMax && this.maxMax == false) {
          this.maxMax = true;
          console.log("ok1");
        }
      }
    },
    async postVideoConsultée() {
      let salarie = this.user.salarie_id;
      let videoList = [];
      let note = JSON.parse(localStorage.note);

      this.collection.forEach(function (element, index) {
        if (note == "undefined" || note == []) {
          this.note[index] = 0;
        }
        videoList[index] = { video_id: element["video_id"], note: note[index] };
      });

      this.videoList = JSON.stringify(videoList);

      if (localStorage.participantsCo !== undefined) {
        let aFinal = JSON.stringify([
          this.videoList,
          localStorage.participantsCo,
        ]);
        await axios
          .post(hostUrl + "/collectif/videoC", aFinal)
          .then((response) => console.log(response.status))
          .catch((error) => console.log("ko = " + error));

        //console.log(aFinal);
        localStorage.removeItem("participantsCo");
      } else {
        await axios
          .post(hostUrl + "/videoC/" + salarie, this.videoList)
          .then(
            (response) =>
              (localStorage.mesExercices = JSON.stringify(response.data))
          )
          .catch((error) => console.log("ko = " + error));
        //console.log('okidoki', 'tableau de Json post = '+this.videoList);
        //console.log(JSON.parse(localStorage.mesExercices));
      }
    },
    changeNote(order) {
      if (order < 0) {
        if (this.activeNote !== "moins") {
          this.note[this.video.position - 1] = -1;
          this.activeNote = "moins";
        } else {
          this.note[this.video.position - 1] = 0;
          this.activeNote = false;
        }
      } else if (order > 0) {
        if (this.activeNote !== "plus") {
          this.note[this.video.position - 1] = +1;
          this.activeNote = "plus";
        } else {
          this.note[this.video.position - 1] = 0;
          this.activeNote = false;
        }
      }
      //console.log(this.note, this.activeNote)
    },
    async getInfo(video_id) {
      let uri = hostUrl + "/vimeo/description/" + video_id;
      await axios
        .get(uri)
        .then(
          (response) => (localStorage.videoInfo = JSON.stringify(response.data))
        )
        .catch((error) => console.log(error));
    },

    async getInfos(array) {
      let uri = hostUrl + "/vimeo/descriptions";
      let json = JSON.stringify(array);
      await axios
        .post(uri, json)
        .then(
          (response) => (localStorage.videoInfo = JSON.stringify(response.data))
        )
        .then(() => (this.loading = false))

        .catch(() => (localStorage.videoInfo = null))
        .catch(() => (this.loading = false))
        .catch(() => (error) => console.log(error));
    },
  },
};
</script>
<style>
.main22 {
  height: 100%;
}
.sessionFinVideo h1 {
  text-align: center;
  margin-bottom: 70%;
}
.finVideo {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.finVideoBoutton {
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  margin: 0;
  width: 45%;
}
/*
.videoKoko {
  position: fixed;
  top: 0;
  left: 0;
}
@media (min-aspect-ratio: 16/9) {
  .videoKoko {
    width: 100% !important;
    height: auto !important; /* En pratique : supérieur à la hauteur du viewport 
  }
}
@media (max-aspect-ratio: 16/9) {
  .videoKoko {
    width: auto !important; /* En pratique : supérieur à la largeur du viewport 
    height: 100% !important;
  }
}*/

.videoKoko {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100% !important;
  height: 100% !important;
  overflow: hidden;
}
@media (min-aspect-ratio: 16/9) {
  .videoKoko {
    height: 210% !important;
    top: -50% !important;
    /* Ou bien height: 200%; top: -50%; */
    /* Ou bien height: 400%; top: -150%; */
  }
}
@media (max-aspect-ratio: 16/9) {
  .videoKoko {
    width: 300% !important;
    left: -100% !important;
    /* Ou bien width: 200%; left: -50%; */
    /* Ou bien width: 400%; left: -150%; */
  }
}
@supports (object-fit: cover) {
  .videoKoko {
    width: 100% !important;
    height: 100% !important;
    top: 0 !important;
    left: 0 !important;
    object-fit: cover !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SessionIndiv.vue